import { useEffect, RefObject } from 'react';

/**
 * 点击元素外部时触发回调的 hook。
 * 支持多个 ref 组成的"安全区域"，点击任一 ref 内部均不触发。
 */
export function useClickOutside(
  refs: RefObject<HTMLElement | null>[],
  callback: () => void,
  enabled: boolean = true,
) {
  useEffect(() => {
    if (!enabled) return;

    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;
      if (refs.some((ref) => ref.current && ref.current.contains(target))) {
        return;
      }
      callback();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [refs, callback, enabled]);
}
